import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["department"]

  changeCompany(event) {
    this.departmentTarget.value = ""
    event.currentTarget.form.requestSubmit()
  }
}
